import styled, { css } from 'styled-components';

import { colors } from '../../assets/variables';
const Wrap = styled.div`
  border-radius: 8px;
  padding: 1.4rem;
  background-size:
    100% 100%,
    cover;
  margin-bottom: 16px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${(props) => {
    if (props.isDesktop) {
      return desktopStyles;
    }
  }}
`;

const ButtonNew = styled.button`
  border-radius: 30px;
  background: white;
  color: ${colors.primary};
  border: 1px solid ${colors.primary};
  text-transform: none;
  height: 46px;
  padding: 16px 32px;
  font-size: 14px;
`;
const ContentWrap = styled.div`
  justify-content: space-evenly;
  display: flex;
  flex-direction: column;
`;
const desktopStyles = css`
  justify-content: space-evenly;
`;

export default {
  Wrap,
  ButtonNew,
  ContentWrap,
};
